import _possibleConstructorReturn from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _wrapNativeSuper from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
import _asyncToGenerator from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _toConsumableArray from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.object.from-entries.js";
import "core-js/modules/esnext.string.match-all.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import _regeneratorRuntime from "/home/runner/work/website/website/node_modules/@babel/runtime/regenerator/index.js";
import { z } from 'zod';
import { getAlpha2Codes } from 'i18n-iso-countries';
import retry from 'async-retry';
import { diary, enable } from 'diary';
import { get } from 'radash';
import { murmur3 } from 'murmurhash-js';
var Query = z.record(z.string(), z.string());
var Page = z.object({
  path: z.string(),
  query: Query,
  referrer: z.string(),
  search: z.string(),
  url: z.string()
});
var SessionStatistics = z.object({
  id: z.string(),
  isReturningVisitor: z.boolean(),
  landingPage: Page,
  count: z.number(),
  activeSessionLength: z.number(),
  averageSessionLength: z.number()
});
var Alpha2Code = z.enum(['unknown'].concat(_toConsumableArray(Object.keys(getAlpha2Codes()))));
var GeoLocation = z.object({
  coordinates: z.object({
    latitude: z.number(),
    longitude: z.number()
  }).optional(),
  city: z.string().optional(),
  postalCode: z.string().optional(),
  region: z.string().optional(),
  regionCode: z.string().optional(),
  country: z.string().optional(),
  countryCode: Alpha2Code.optional(),
  continent: z.string().optional(),
  timezone: z.string().optional()
});
var JsonLiteral = z.lazy(function () {
  return z.union([z.string(), z.number(), z.boolean(), z.null(), z.symbol(), z.array(JsonLiteral), JsonLiteralObject]);
});
var JsonLiteralObject = z.record(z.string(), z.union([JsonLiteral, z.array(JsonLiteral)]));
var Json = z.lazy(function () {
  return z.union([JsonLiteral, z.array(Json), z.record(Json)]);
});
var JsonObject = z.record(Json);
var Profile = z.object({
  id: z.string(),
  stableId: z.string(),
  random: z.number(),
  audiences: z.array(z.string()),
  traits: JsonObject,
  location: GeoLocation,
  session: SessionStatistics
});
var RequestBodyOptions = z.object({
  features: z.array(z.string()).optional()
});
var SelectedVariantInfo = z.object({
  experienceId: z.string(),
  variantIndex: z.number(),
  variants: z.record(z.string())
});
var withResponseEnvelope = function withResponseEnvelope(dataSchema) {
  return z.object({
    data: dataSchema,
    message: z.string(),
    error: z.boolean().nullable()
  });
};
var CreateProfileRequestBody = z.object({
  events: z.array(z.unknown()).min(1),
  options: RequestBodyOptions.optional()
});
var CreateProfileResponse = withResponseEnvelope(z.object({
  profile: Profile,
  experiences: z.array(SelectedVariantInfo)
}));
var UpdateProfileRequestBody = z.object({
  events: z.array(z.unknown()).min(1),
  options: RequestBodyOptions.optional()
});
var UpdateProfileResponse = withResponseEnvelope(z.object({
  profile: Profile,
  experiences: z.array(SelectedVariantInfo)
}));
var UpsertManyProfilesRequestBody = z.object({
  events: z.array(z.unknown()).min(1),
  options: RequestBodyOptions.optional()
});
var UpsertManyProfilesResponse = withResponseEnvelope(z.object({
  profiles: z.array(Profile).optional()
}));
var Campaign = z.object({
  name: z.string().optional(),
  source: z.string().optional(),
  medium: z.string().optional(),
  term: z.string().optional(),
  content: z.string().optional()
});
var PageviewProperties = z.object({
  path: z.string(),
  query: Query,
  referrer: z.string(),
  search: z.string(),
  title: z.string(),
  url: z.string(),
  category: z.string().optional()
}).catchall(Json);
var Pageview = 'page';
var Track = 'track';
var Identify = 'identify';
var Screen = 'screen';
var Group = 'group';
var Alias = 'alias';
var Component = 'component';
var LEGACY_ANONYMOUS_ID = '__anon_id';
var ANONYMOUS_ID = '__nt_anonymous_id__';
var DEBUG_FLAG = '__nt_debug__';
var PROFILE_FALLBACK_CACHE = '__nt_profile__';
var EXPERIENCES_FALLBACK_CACHE = '__nt_experiences__';
var PROFILE_CHANGE = 'profile-change';
var PROFILE_RESET = 'profile-reset';
var CONSENT = '__nt-consent__';
var EMPTY_MERGE_ID = 'nt:empty-merge-id';
var NINETAILED_ANONYMOUS_ID_COOKIE = 'ntaid';
var Logger = /*#__PURE__*/function () {
  function Logger() {
    _classCallCheck(this, Logger);
    this.name = '@ninetailed/experience.js';
    this.diary = void 0;
    this.sinks = [];
    this.diary = diary(this.name, this.onLogEvent.bind(this));
    enable(this.name);
  }
  return _createClass(Logger, [{
    key: "addSink",
    value: function addSink(sink) {
      this.sinks = [].concat(_toConsumableArray(this.sinks.filter(function (existingSink) {
        return existingSink.name !== sink.name;
      })), [sink]);
    }
  }, {
    key: "removeSink",
    value: function removeSink(name) {
      this.sinks = this.sinks.filter(function (sink) {
        return sink.name !== name;
      });
    }
  }, {
    key: "removeSinks",
    value: function removeSinks() {
      this.sinks = [];
    }
  }, {
    key: "debug",
    value: function debug(message) {
      var _this$diary;
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      (_this$diary = this.diary).debug.apply(_this$diary, [message].concat(args));
    }
  }, {
    key: "info",
    value: function info(message) {
      var _this$diary2;
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }
      (_this$diary2 = this.diary).info.apply(_this$diary2, [message].concat(args));
    }
  }, {
    key: "log",
    value: function log(message) {
      var _this$diary3;
      for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }
      (_this$diary3 = this.diary).log.apply(_this$diary3, [message].concat(args));
    }
  }, {
    key: "warn",
    value: function warn(message) {
      var _this$diary4;
      for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        args[_key4 - 1] = arguments[_key4];
      }
      (_this$diary4 = this.diary).warn.apply(_this$diary4, [message].concat(args));
    }
  }, {
    key: "error",
    value: function error(message) {
      var _this$diary5;
      for (var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
        args[_key5 - 1] = arguments[_key5];
      }
      (_this$diary5 = this.diary).error.apply(_this$diary5, [message].concat(args));
    }
  }, {
    key: "fatal",
    value: function fatal(message) {
      var _this$diary6;
      for (var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
        args[_key6 - 1] = arguments[_key6];
      }
      (_this$diary6 = this.diary).fatal.apply(_this$diary6, [message].concat(args));
    }
  }, {
    key: "onLogEvent",
    value: function onLogEvent(event) {
      this.sinks.forEach(function (sink) {
        sink.ingest(event);
      });
    }
  }]);
}();
var logger = new Logger();
var fetchTimeout = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url, init) {
    var _ref2,
      _ref2$fetchImpl,
      _fetchImpl,
      timeout,
      onTimeout,
      controller,
      id,
      response,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _ref2 = _args.length > 2 && _args[2] !== undefined ? _args[2] : {}, _ref2$fetchImpl = _ref2.fetchImpl, _fetchImpl = _ref2$fetchImpl === void 0 ? fetch : _ref2$fetchImpl;
          timeout = init.timeout, onTimeout = init.onTimeout;
          controller = new AbortController();
          id = setTimeout(function () {
            if (typeof onTimeout === 'function') {
              logger.error(new Error('Ninetailed Request timed out.'));
            }
            controller.abort();
          }, timeout);
          _context.next = 6;
          return _fetchImpl(url, Object.assign({}, init, {
            signal: controller.signal
          }));
        case 6:
          response = _context.sent;
          clearTimeout(id);
          return _context.abrupt("return", response);
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function fetchTimeout(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var GetProfileResponse = withResponseEnvelope(z.object({
  profile: Profile,
  experiences: z.array(SelectedVariantInfo)
}));
var BASE_URL = 'https://experience.ninetailed.co';
var FEATURES = {
  IP_ENRICHMENT: 'ip-enrichment',
  LOCATION: 'location'
};
var DEFAULT_ENVIRONMENT = 'main';
var HttpError = /*#__PURE__*/function (_Error) {
  function HttpError(message) {
    var _this;
    var status = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
    _classCallCheck(this, HttpError);
    _this = _callSuper(this, HttpError, [message]);
    _this.status = status;
    Object.setPrototypeOf(_this, HttpError.prototype);
    return _this;
  }
  _inherits(HttpError, _Error);
  return _createClass(HttpError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
var NinetailedApiClient = /*#__PURE__*/function () {
  function NinetailedApiClient(_ref3) {
    var clientId = _ref3.clientId,
      _ref3$environment = _ref3.environment,
      environment = _ref3$environment === void 0 ? DEFAULT_ENVIRONMENT : _ref3$environment,
      _ref3$url = _ref3.url,
      url = _ref3$url === void 0 ? BASE_URL : _ref3$url,
      _ref3$fetchImpl = _ref3.fetchImpl,
      fetchImpl = _ref3$fetchImpl === void 0 ? fetch : _ref3$fetchImpl;
    _classCallCheck(this, NinetailedApiClient);
    this.clientId = void 0;
    this.environment = void 0;
    this.url = void 0;
    this.fetchImpl = void 0;
    this.constructOptions = function (options) {
      var bodyOptions = {};
      if (options.enabledFeatures && Array.isArray(options.enabledFeatures) && options.enabledFeatures.length > 0) {
        bodyOptions.features = options.enabledFeatures;
      }
      return bodyOptions;
    };
    this.clientId = clientId;
    this.environment = environment;
    this.url = url;
    this.fetchImpl = fetchImpl;
  }
  return _createClass(NinetailedApiClient, [{
    key: "logRequestError",
    value: function logRequestError(error, _ref4) {
      var requestName = _ref4.requestName;
      if (error instanceof Error) {
        if (error.name === 'AbortError') {
          logger.warn("".concat(requestName, " request aborted due to network issues. This request is not retryable."));
        } else {
          logger.error("".concat(requestName, " request failed with error: [").concat(error.name, "] ").concat(error.message));
        }
      }
    }
  }, {
    key: "upsertProfile",
    value: function () {
      var _upsertProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref5, options) {
        var profileId, events;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              profileId = _ref5.profileId, events = _ref5.events;
              if (profileId) {
                _context2.next = 5;
                break;
              }
              return _context2.abrupt("return", this.createProfile({
                events: events
              }, options));
            case 5:
              return _context2.abrupt("return", this.updateProfile({
                profileId: profileId,
                events: events
              }, options));
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function upsertProfile(_x3, _x4) {
        return _upsertProfile.apply(this, arguments);
      }
      return upsertProfile;
    }()
  }, {
    key: "retryRequest",
    value: function retryRequest(request, name, options) {
      var _options$retries, _options$minRetryTime;
      return retry( /*#__PURE__*/function () {
        var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(bail) {
          var response;
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return request;
              case 3:
                response = _context3.sent;
                if (!(response.status === 503)) {
                  _context3.next = 6;
                  break;
                }
                throw new HttpError("".concat(name, " request failed with status: \"[").concat(response.status, "] ").concat(response.statusText, "\"."), 503);
              case 6:
                if (response.ok) {
                  _context3.next = 9;
                  break;
                }
                bail(new Error("".concat(name, " request failed with status: \"[").concat(response.status, "] ").concat(response.statusText, " - traceparent: ").concat(response.headers.get('traceparent'), "\". This request is not retryable")));
                return _context3.abrupt("return", null);
              case 9:
                logger.debug("".concat(name, " response: "), response);
                return _context3.abrupt("return", response);
              case 13:
                _context3.prev = 13;
                _context3.t0 = _context3["catch"](0);
                if (!(_context3.t0 instanceof HttpError && _context3.t0.status === 503)) {
                  _context3.next = 17;
                  break;
                }
                throw _context3.t0;
              case 17:
                if (_context3.t0 instanceof Error) {
                  bail(_context3.t0);
                } else {
                  bail(new Error("".concat(name, " request failed with an unknown error. This request is not retryable.")));
                }
                return _context3.abrupt("return", null);
              case 19:
              case "end":
                return _context3.stop();
            }
          }, _callee3, null, [[0, 13]]);
        }));
        return function (_x5) {
          return _ref6.apply(this, arguments);
        };
      }(), {
        retries: (_options$retries = options.retries) != null ? _options$retries : 1,
        minTimeout: (_options$minRetryTime = options.minRetryTimeout) != null ? _options$minRetryTime : 0,
        onRetry: function onRetry(error, attempt) {
          return logger.error("".concat(error.message, " Retrying (attempt ").concat(attempt, ")."));
        }
      });
    }
  }, {
    key: "makeProfileMutationRequest",
    value: function makeProfileMutationRequest(url, payload, name, options) {
      return this.retryRequest(fetchTimeout(this.constructUrl(url, options), {
        method: 'POST',
        headers: this.constructHeaders(options),
        body: JSON.stringify(payload),
        timeout: options.timeout || 3000
      }, {
        fetchImpl: this.fetchImpl
      }), name, options);
    }
  }, {
    key: "getProfile",
    value: function () {
      var _getProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(id) {
        var options,
          requestName,
          response,
          _GetProfileResponse$p,
          data,
          _args4 = arguments;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              options = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : {};
              requestName = 'Get Profile';
              logger.info("Sending ".concat(requestName, " request."));
              _context4.prev = 3;
              _context4.next = 6;
              return this.retryRequest(fetchTimeout(this.constructUrl("/v2/organizations/".concat(this.clientId, "/environments/").concat(this.environment, "/profiles/").concat(id), options), {
                method: 'GET',
                timeout: options.timeout || 3000
              }, {
                fetchImpl: this.fetchImpl
              }), 'Get Profile', options);
            case 6:
              response = _context4.sent;
              _context4.t0 = GetProfileResponse;
              _context4.next = 10;
              return response.json();
            case 10:
              _context4.t1 = _context4.sent;
              _GetProfileResponse$p = _context4.t0.parse.call(_context4.t0, _context4.t1);
              data = _GetProfileResponse$p.data;
              logger.debug("".concat(requestName, " request succesfully completed."));
              return _context4.abrupt("return", data);
            case 17:
              _context4.prev = 17;
              _context4.t2 = _context4["catch"](3);
              this.logRequestError(_context4.t2, {
                requestName: requestName
              });
              throw _context4.t2;
            case 21:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[3, 17]]);
      }));
      function getProfile(_x6) {
        return _getProfile.apply(this, arguments);
      }
      return getProfile;
    }()
    /**
     * Creates a profile and returns it.
     * Use the given profileId for subsequent update requests.
     * The events will be used to aggregate the new Profile state.
     */
  }, {
    key: "createProfile",
    value: (function () {
      var _createProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref7) {
        var events,
          options,
          requestName,
          body,
          response,
          _CreateProfileRespons,
          data,
          _args5 = arguments;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              events = _ref7.events;
              options = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : {};
              requestName = 'Create Profile';
              logger.info("Sending ".concat(requestName, " request."));
              body = {
                events: events,
                options: this.constructOptions(options)
              };
              logger.debug("".concat(requestName, " request Body: "), body);
              _context5.prev = 6;
              _context5.next = 9;
              return this.makeProfileMutationRequest("/v2/organizations/".concat(this.clientId, "/environments/").concat(this.environment, "/profiles"), body, 'Create Profile', options);
            case 9:
              response = _context5.sent;
              _context5.t0 = CreateProfileResponse;
              _context5.next = 13;
              return response.json();
            case 13:
              _context5.t1 = _context5.sent;
              _CreateProfileRespons = _context5.t0.parse.call(_context5.t0, _context5.t1);
              data = _CreateProfileRespons.data;
              logger.debug("".concat(requestName, " request succesfully completed."));
              return _context5.abrupt("return", data);
            case 20:
              _context5.prev = 20;
              _context5.t2 = _context5["catch"](6);
              this.logRequestError(_context5.t2, {
                requestName: requestName
              });
              throw _context5.t2;
            case 24:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[6, 20]]);
      }));
      function createProfile(_x7) {
        return _createProfile.apply(this, arguments);
      }
      return createProfile;
    }()
    /**
     * Updates a profile with the given profileId.
     * The events will be used to aggregate the new Profile state.
     */
    )
  }, {
    key: "updateProfile",
    value: (function () {
      var _updateProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref8) {
        var profileId,
          events,
          options,
          requestName,
          body,
          response,
          _UpdateProfileRespons,
          data,
          _args6 = arguments;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              profileId = _ref8.profileId, events = _ref8.events;
              options = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : {};
              requestName = 'Update Profile';
              logger.info("Sending ".concat(requestName, " request."));
              body = {
                events: events,
                options: this.constructOptions(options)
              };
              logger.debug("".concat(requestName, " request Body: "), body);
              _context6.prev = 6;
              _context6.next = 9;
              return this.makeProfileMutationRequest("/v2/organizations/".concat(this.clientId, "/environments/").concat(this.environment, "/profiles/").concat(profileId), body, requestName, options);
            case 9:
              response = _context6.sent;
              _context6.t0 = UpdateProfileResponse;
              _context6.next = 13;
              return response.json();
            case 13:
              _context6.t1 = _context6.sent;
              _UpdateProfileRespons = _context6.t0.parse.call(_context6.t0, _context6.t1);
              data = _UpdateProfileRespons.data;
              logger.debug("".concat(requestName, " request successfully completed."));
              return _context6.abrupt("return", data);
            case 20:
              _context6.prev = 20;
              _context6.t2 = _context6["catch"](6);
              this.logRequestError(_context6.t2, {
                requestName: requestName
              });
              throw _context6.t2;
            case 24:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[6, 20]]);
      }));
      function updateProfile(_x8) {
        return _updateProfile.apply(this, arguments);
      }
      return updateProfile;
    }()
    /**
     * Sends multiple events to the Ninetailed API.
     * Every events needs to have a anonymous ID.
     * Profiles will get created or updated according to the set anonymous ID.
     *
     * This method is intended to be used from server environments.
     */
    )
  }, {
    key: "upsertManyProfiles",
    value: (function () {
      var _upsertManyProfiles = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref9) {
        var events,
          options,
          requestName,
          body,
          response,
          _UpsertManyProfilesRe,
          profiles,
          _args7 = arguments;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              events = _ref9.events;
              options = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : {};
              requestName = 'Upsert Many Profiles';
              logger.info("Sending ".concat(requestName, " request."));
              body = {
                events: events,
                options: this.constructOptions(options)
              };
              logger.debug("".concat(requestName, " request Body: "), body);
              _context7.prev = 6;
              _context7.next = 9;
              return this.makeProfileMutationRequest("/v2/organizations/".concat(this.clientId, "/environments/").concat(this.environment, "/events"), body, requestName, Object.assign({
                plainText: false
              }, options));
            case 9:
              response = _context7.sent;
              _context7.t0 = UpsertManyProfilesResponse;
              _context7.next = 13;
              return response.json();
            case 13:
              _context7.t1 = _context7.sent;
              _UpsertManyProfilesRe = _context7.t0.parse.call(_context7.t0, _context7.t1);
              profiles = _UpsertManyProfilesRe.data.profiles;
              logger.debug("".concat(requestName, " request successfully completed."));
              return _context7.abrupt("return", profiles);
            case 20:
              _context7.prev = 20;
              _context7.t2 = _context7["catch"](6);
              this.logRequestError(_context7.t2, {
                requestName: requestName
              });
              throw _context7.t2;
            case 24:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this, [[6, 20]]);
      }));
      function upsertManyProfiles(_x9) {
        return _upsertManyProfiles.apply(this, arguments);
      }
      return upsertManyProfiles;
    }())
  }, {
    key: "constructUrl",
    value: function constructUrl(path, options) {
      var url = new URL(path, this.url);
      if (options.preflight) {
        url.searchParams.set('type', 'preflight');
      }
      if (options.locale) {
        url.searchParams.set('locale', options.locale);
      }
      return url.toString();
    }
  }, {
    key: "constructHeaders",
    value: function constructHeaders(options) {
      var _options$plainText;
      var headers = new Map();
      if (options.ip) {
        headers.set('X-Force-IP', options.ip);
      }
      if ((_options$plainText = options.plainText) != null ? _options$plainText : true) {
        headers.set('Content-Type', 'text/plain');
      } else {
        headers.set('Content-Type', 'application/json');
      }
      return Object.fromEntries(headers);
    }
  }]);
}();
var ConsoleLogSink = /*#__PURE__*/function () {
  function ConsoleLogSink() {
    _classCallCheck(this, ConsoleLogSink);
    this.name = 'ConsoleLogSink';
  }
  return _createClass(ConsoleLogSink, [{
    key: "ingest",
    value: function ingest(event) {
      var consoleLogMap = {
        debug: console.debug,
        info: console.info,
        log: console.log,
        warn: console.warn,
        error: console.error,
        fatal: console.error
      };
      var logFn = consoleLogMap[event.level];
      if (logFn) {
        logFn.apply(void 0, _toConsumableArray(event.messages));
      }
    }
  }]);
}();
var OnLogLogSink = /*#__PURE__*/function () {
  function OnLogLogSink(onLog) {
    _classCallCheck(this, OnLogLogSink);
    this.name = 'OnLogLogSink';
    this.onLog = onLog;
  }
  return _createClass(OnLogLogSink, [{
    key: "ingest",
    value: function ingest(event) {
      if (!event.messages.length) {
        return;
      }
      if (event.level == 'error' || event.level === 'fatal') {
        return;
      }
      if (typeof event.messages[0] !== 'string') {
        return;
      }
      this.onLog.apply(this, [event.messages[0]].concat(_toConsumableArray(event.messages.slice(1))));
    }
  }]);
}();
var OnErrorLogSink = /*#__PURE__*/function () {
  function OnErrorLogSink(onError) {
    _classCallCheck(this, OnErrorLogSink);
    this.name = 'OnErrorLogSink';
    this.onError = onError;
  }
  return _createClass(OnErrorLogSink, [{
    key: "ingest",
    value: function ingest(event) {
      if (!event.messages.length) {
        return;
      }
      if (event.level === 'error' || event.level === 'fatal') {
        if (event.messages[0] instanceof Error || typeof event.messages[0] === 'string') {
          this.onError.apply(this, [event.messages[0]].concat(_toConsumableArray(event.messages.slice(1))));
        }
      }
    }
  }]);
}();
var buildQuery = function buildQuery(url) {
  var result = {};
  try {
    var parsedUrl = new URL(url);
    parsedUrl.searchParams.forEach(function (value, key) {
      result[key] = value;
    });
  } catch (error) {
    //noop
  }
  return result;
};
var buildCampaign = function buildCampaign(ctx) {
  var params = buildQuery(ctx.url);
  var campaign = {};
  if (params['utm_campaign']) {
    campaign.name = params['utm_campaign'];
  }
  if (params['utm_source']) {
    campaign.source = params['utm_source'];
  }
  if (params['utm_medium']) {
    campaign.medium = params['utm_medium'];
  }
  if (params['utm_term']) {
    campaign.term = params['utm_term'];
  }
  if (params['utm_content']) {
    campaign.content = params['utm_content'];
  }
  return campaign;
};
var buildPage = function buildPage(ctx) {
  try {
    var query = buildQuery(ctx.url);
    var url = new URL(ctx.url);
    return {
      path: url.pathname,
      query: query,
      referrer: ctx.referrer,
      search: url.search,
      url: ctx.url
    };
  } catch (error) {
    return {
      path: '',
      query: {},
      referrer: '',
      search: '',
      url: ''
    };
  }
};
var buildEvent = function buildEvent(_ref10) {
  var messageId = _ref10.messageId,
    timestamp = _ref10.timestamp,
    type = _ref10.type,
    ctx = _ref10.ctx,
    location = _ref10.location;
  var date = new Date(timestamp).toISOString();
  return {
    channel: 'web',
    context: {
      library: {
        name: 'Ninetailed React Analytics SDK',
        version: "7.7.3"
      },
      userAgent: ctx.userAgent,
      campaign: buildCampaign(ctx),
      locale: ctx.locale,
      page: buildPage(ctx),
      gdpr: {
        isConsentGiven: true
      },
      location: location
    },
    messageId: messageId,
    originalTimestamp: date,
    timestamp: date,
    sentAt: date,
    type: type
  };
};
var buildPageEvent = function buildPageEvent(data) {
  var _data$ctx$document;
  return Object.assign({}, buildEvent(Object.assign({}, data, {
    type: 'page'
  })), {
    properties: Object.assign({}, data.properties, buildPage(data.ctx), {
      title: ((_data$ctx$document = data.ctx.document) == null ? void 0 : _data$ctx$document.title) || ''
    })
  });
};
var buildTrackEvent = function buildTrackEvent(data) {
  return Object.assign({}, buildEvent(Object.assign({}, data, {
    type: 'track'
  })), {
    event: data.event,
    properties: data.properties
  });
};
var buildIdentifyEvent = function buildIdentifyEvent(data) {
  return Object.assign({}, buildEvent(Object.assign({}, data, {
    type: 'identify'
  })), {
    traits: data.traits,
    userId: data.userId
  });
};
var buildComponentViewEvent = function buildComponentViewEvent(data) {
  return Object.assign({}, buildEvent(Object.assign({}, data, {
    type: 'component'
  })), {
    componentId: data.componentId,
    experienceId: data.experienceId,
    variantIndex: data.variantIndex
  });
};
var isBrowser = function isBrowser() {
  return typeof window !== 'undefined';
};
var pipe = function pipe() {
  for (var _len7 = arguments.length, fns = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
    fns[_key7] = arguments[_key7];
  }
  return function (value) {
    return fns.reduce(function (acc, fn) {
      return fn(acc);
    }, value);
  };
};
var unionBy = function unionBy(array1, array2, prop) {
  return Object.values([].concat(_toConsumableArray(array1), _toConsumableArray(array2)).reduce(function (acc, item) {
    if (!(prop in acc)) {
      acc[item[prop]] = item;
    }
    return acc;
  }, {}));
};
var pickBy = function pickBy(object, predicate) {
  return Object.keys(object).reduce(function (acc, key) {
    if (predicate(object[key], key)) {
      acc[key] = object[key];
    }
    return acc;
  }, {});
};

/**
 *
 * This function is a copy of the radash `template` function
 * https://github.com/rayepps/radash/blob/c378bd1bc401045ed7d8e5e47b275d2159ce43d5/src/string.ts#L118
 */
var template = function template(str, data) {
  var regex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : /\{\{(.+?)\}\}/g;
  return Array.from(str.matchAll(regex)).reduce(function (acc, match) {
    var _get;
    return acc.replace(match[0], (_get = get(data, match[1].trim())) != null ? _get : 'undefined');
  }, str);
};
var isPageViewEvent = function isPageViewEvent(event) {
  return event.type === 'page';
};
var isTrackEvent = function isTrackEvent(event) {
  return event.type === 'track';
};
var isIdentifyEvent = function isIdentifyEvent(event) {
  return event.type === 'identify';
};
var isComponentViewEvent = function isComponentViewEvent(event) {
  return event.type === 'component';
};
var EXPERIENCE_TRAIT_PREFIX = 'nt_experiment_';
var LOWER_BOUND = 0;
var UPPER_BOUND = 4294967295;
var normalize = function normalize(val, min, max) {
  return (val - min) / (max - min);
};
var getRandom = function getRandom(text) {
  var hash = murmur3(text, 0);
  var random = normalize(hash, LOWER_BOUND, UPPER_BOUND);
  return random;
};
var getTrafficRandom = function getTrafficRandom(profile, experience) {
  return getRandom("traffic-".concat(experience.id, "-").concat(profile.stableId));
};
var getDistributionRandom = function getDistributionRandom(profile, experience) {
  return getRandom("distribution-".concat(experience.id, "-").concat(profile.stableId));
};
var isExperienceMatch = function isExperienceMatch(_ref11) {
  var experience = _ref11.experience,
    profile = _ref11.profile;
  var trafficRandom = getTrafficRandom(profile, experience);
  logger.info("The traffic random factor for experience ".concat(experience.id, " is ").concat(trafficRandom, ". It's traffic allocation is set to ").concat(experience.trafficAllocation, "."));
  var isInTrafficRange = experience.trafficAllocation > trafficRandom;
  var matchesAudience = !experience.audience || profile.audiences.includes(experience.audience.id);
  logger.info("Is the profile in traffic allocation range? ".concat(isInTrafficRange ? 'yes' : 'no', ".\n\n      Does the profile match the audience of the experience? ").concat(matchesAudience ? 'yes' : 'no', ".\n"));
  return isInTrafficRange && matchesAudience;
};
var pickExperimentTraits = function pickExperimentTraits(profile) {
  var experimentTraits = {};
  for (var key in profile.traits) {
    if (key.startsWith(EXPERIENCE_TRAIT_PREFIX) && typeof profile.traits[key] === 'boolean' && profile.traits[key] === true) {
      experimentTraits[key] = profile.traits[key];
    }
  }
  return experimentTraits;
};
var selectActiveExperiments = function selectActiveExperiments(experiments, profile) {
  var experimentTraits = pickExperimentTraits(profile);
  var experimentTraitsIds = Object.keys(experimentTraits).map(function (id) {
    return id.replace(EXPERIENCE_TRAIT_PREFIX, '');
  });
  var activeExperiments = experiments.filter(function (experiment) {
    return experimentTraitsIds.includes(experiment.id);
  });
  return activeExperiments;
};
var selectBaselineWithVariants = function selectBaselineWithVariants(experience, baseline) {
  var _experience$component;
  return (_experience$component = experience.components.find(function (baselineWithVariants) {
    return baselineWithVariants.baseline.id === baseline.id;
  })) != null ? _experience$component : null;
};
var selectDistribution = function selectDistribution(_ref12) {
  var experience = _ref12.experience,
    profile = _ref12.profile;
  var distributionRandom = getDistributionRandom(profile, experience);
  logger.log("The distribution random factor for experience ".concat(experience.id, " is ").concat(distributionRandom, ". It's distribution is set to ").concat(JSON.stringify(experience.distribution, null, 2), "."));
  var distribution = experience.distribution.find(function (_ref13) {
    var start = _ref13.start,
      end = _ref13.end;
    return distributionRandom >= start && distributionRandom <= end;
  } // this overlaps on one value for each boundary but we just find the first match
  );
  if (!distribution) {
    return {
      index: 0,
      start: 0,
      end: 1
    };
  }
  return distribution;
};
var selectExperience = function selectExperience(_ref14) {
  var experiences = _ref14.experiences,
    profile = _ref14.profile;
  var selectedExperience = experiences.find(function (experience) {
    return isExperienceMatch({
      experience: experience,
      profile: profile
    });
  });
  return selectedExperience != null ? selectedExperience : null;
};
var selectVariants = function selectVariants(experience, baseline) {
  var baselineWithVariants = selectBaselineWithVariants(experience, baseline);
  if (!baselineWithVariants) {
    return [];
  }
  return baselineWithVariants.variants;
};
var selectHasVariants = function selectHasVariants(experience, baseline) {
  var variants = selectVariants(experience, baseline);
  return variants.length > 0;
};
var selectVariant = function selectVariant(_ref15) {
  var baseline = _ref15.baseline,
    experience = _ref15.experience,
    profile = _ref15.profile;
  var variants = selectVariants(experience, baseline);
  var baselineVariant = Object.assign({}, baseline, {
    hidden: false
  });
  if (!variants.length) {
    return {
      variant: baselineVariant,
      index: 0
    };
  }
  var distribution = selectDistribution({
    experience: experience,
    profile: profile
  });
  if (!distribution) {
    return {
      variant: baselineVariant,
      index: 0
    };
  }
  if (distribution.index === 0) {
    return {
      variant: baselineVariant,
      index: 0
    };
  }
  var selectableVariants = [baselineVariant].concat(_toConsumableArray(variants));
  if (selectableVariants.length <= distribution.index) {
    logger.warn("A distribution for a variant was selected but it's metadata could not be found.");
    return {
      variant: baselineVariant,
      index: 0
    };
  }
  var variant = selectableVariants[distribution.index];
  return {
    variant: variant,
    index: distribution.index
  };
};
export { ANONYMOUS_ID, Alias, Alpha2Code, CONSENT, Campaign, Component, ConsoleLogSink, CreateProfileRequestBody, CreateProfileResponse, DEBUG_FLAG, EMPTY_MERGE_ID, EXPERIENCES_FALLBACK_CACHE, EXPERIENCE_TRAIT_PREFIX, FEATURES, GeoLocation, Group, Identify, Json, JsonLiteral, JsonLiteralObject, JsonObject, LEGACY_ANONYMOUS_ID, Logger, NINETAILED_ANONYMOUS_ID_COOKIE, NinetailedApiClient, OnErrorLogSink, OnLogLogSink, PROFILE_CHANGE, PROFILE_FALLBACK_CACHE, PROFILE_RESET, Page, Pageview, PageviewProperties, Profile, JsonObject as Properties, Query, RequestBodyOptions, Screen, SelectedVariantInfo, SessionStatistics, Track, JsonObject as Traits, UpdateProfileRequestBody, UpdateProfileResponse, UpsertManyProfilesRequestBody, UpsertManyProfilesResponse, buildCampaign, buildComponentViewEvent, buildEvent, buildIdentifyEvent, buildPage, buildPageEvent, buildQuery, buildTrackEvent, fetchTimeout, getDistributionRandom, getTrafficRandom, isBrowser, isComponentViewEvent, isExperienceMatch, isIdentifyEvent, isPageViewEvent, isTrackEvent, logger, pickBy, pickExperimentTraits, pipe, selectActiveExperiments, selectBaselineWithVariants, selectDistribution, selectExperience, selectHasVariants, selectVariant, selectVariants, template, unionBy };